import React, { useState } from 'react';
let resolution = window.RESOLUTION;
if(window.innerWidth >= 1920 && window.innerHeight >= 1080){resolution = "FHD";}else{resolution = "HD";}
const userAgent = navigator.userAgent.toLowerCase();
if (userAgent.includes('webos') || userAgent.includes('lg') || userAgent.includes('web0s')) {
resolution = 'FHD';
}
const SubscriptionRental = () => {    
    const styles = {
        SubscriptionRentalContainer: {
          display: 'flex',
          flexDirection: 'column',
          background: 'transparent'  ,
          width: '99vw',
          height: '100vh',    
          backgroundSize: 'cover',
          backgroundPosition: 'center', // Center the background image
          backgroundRepeat: 'no-repeat', // Do not repeat the background image
          color: '#D0D0D0',
          fontSize: '18px'
        },
      };
  return (
    <div style={styles.SubscriptionRentalContainer}>
                
    </div>
      
  );
};
export default SubscriptionRental;